import { TicketIcon } from 'lucide-react';
import {
  PiBagDuotone,
  PiConfettiDuotone,
  PiFlyingSaucerDuotone,
  PiMagicWandDuotone,
  PiPhoneDuotone,
} from 'react-icons/pi';
import { RiPieChart2Fill } from 'react-icons/ri';
import { TbUserFilled } from 'react-icons/tb';

export const featureData = [
  {
    id: 1,
    icon: <TicketIcon className='size-10 text-[#FF6250]' />,
    color: 'bg-[#FF6250]/20',
    name: 'Your Special Ticketing Partner',
    desc: 'What sets us apart is that we are not just an ordinary ticket booking platform, we come as a partner, so from designing posters to getting those sponsors  whatever is required to make your event successful. We will do it .',
  },
  {
    id: 2,
    icon: <PiMagicWandDuotone className='size-10 text-[#FF6250]' />,
    color: 'bg-[#FF6250]/20',
    name: 'Dedicated Relationship Manager',
    desc: "Elevate your event planning experience with Fydo's Dedicated Relationship Manager. From seamless setup to event day troubleshooting, our expert manager becomes your invaluable ally, providing personalised support and ensuring a stress-free journey for organisers",
  },
  {
    id: 3,
    icon: <PiFlyingSaucerDuotone className='size-10 pl-1 text-[#009379]' />,
    color: 'bg-[#009379]/20',
    name: 'On Demand Settlement',
    desc: 'Get flexibility like never before, request settlements whenever you need them. Take charge of your event’s finances with ease and on your terms, ensuring a stress-free and efficient event planning process.',
  },
  {
    id: 3,
    icon: <PiConfettiDuotone className='size-10 text-[#F8D57E]' />,
    color: 'bg-[#F8D57E]/20',
    name: 'Customer Analytics Data',
    desc: "Unlock actionable insights with Fydo's Customer Analytics Data feature. Gain a comprehensive understanding of your event attendees, their preferences, and behaviours. Leverage this valuable data to refine your strategies, enhance engagement, and create events that resonate with your audience.",
  },
  {
    id: 4,
    icon: <PiBagDuotone className='size-10 text-[#F2D52E]' />,
    color: 'bg-[#F8D52E]/20',
    name: '360 Degree Marketing & Branding',
    desc: "Transform your event's presence with Fydo's holistic marketing approach. From crafting eye-catching event posters to strategic promotions on platforms like Facebook, Instagram, WhatsApp, and email, we offer comprehensive 360-degree marketing support.",
  },
  {
    id: 4,
    icon: <PiPhoneDuotone className='size-10 text-[#8DEF5E]' />,
    color: 'bg-[#8DEF5E]/20',
    name: '24/7 Call Support',
    desc: "Experience unwavering support with Fydo's 24/7 On-Call Assistance. Whether you're an organiser seeking guidance or a customer with inquiries, our dedicated support team is just a call away. Count on us around the clock to ensure a smooth and worry-free event experience for everyone involved.",
  },

  {
    id: 5,
    icon: <TbUserFilled className='size-10 text-[#005E93]' />,
    color: 'bg-[#005E93]/20',
    name: 'On site representative on event day',
    desc: "Ensure a seamless event day experience with Fydo's on-site representative service. When needed, our dedicated representatives are there to assist, troubleshoot, and ensure everything runs smoothly, allowing you to focus on creating memorable moments for your attendees.",
  },

  {
    id: 6,
    icon: <RiPieChart2Fill className='size-10 text-[#35C56E]' />,
    color: 'bg-[#35C56E]/20',
    name: 'Exclusive App for Organisers',
    desc: "Transform event management with Greet, Fydo's Exclusive Organizer App. Effortlessly check in attendees and access the complete list of booked tickets, putting the power of precision in your hands. Real-time updates and comprehensive insights make Greet your go-to command center for seamless and successful events.",
  },
];
